import '@patsnap-ui/icon/assets/solid/TextSurround.svg';
import '@patsnap-ui/icon/assets/solid/OneTwoThree.svg';
import '@patsnap-ui/icon/assets/solid/Calendar7.svg';
import '@patsnap-ui/icon/assets/solid/CheckboxOnOutline.svg';
import '@patsnap-ui/icon/assets/solid/TreeHorizontal.svg';
import '@patsnap-ui/icon/assets/solid/Url.svg';
import '@patsnap-ui/icon/assets/solid/Images.svg';
export const fieldPtIconMappings = {
    STRING: 'SolidTextSurround',
    NUM: 'SolidOneTwoThree',
    DATE: 'SolidCalendar7',
    OPTION: 'SolidCheckboxOnOutline',
    LAYER: 'SolidTreeHorizontal',
    URL: 'SolidUrl',
    IMAGE: 'SolidImages',
};
export const tableHeaderIconMappings = {
    STRING: 'icon-text',
    NUM: 'icon-numeric',
    DATE: 'icon-date',
    OPTION: 'icon-drop-downmenu',
    LAYER: 'icon-drop-downtree',
    URL: 'icon-url',
    IMAGE: 'icon-images',
    freeze: 'icon-pin',
    unfreeze: 'icon-pin',
    edit: 'icon-edit',
    asc: 'icon-min-max',
    desc: 'icon-max-min',
    delete: 'icon-delete',
    hide: 'icon-not-see',
};
export const tableHeaderSortMappings = {
    APD: {
        has_desc: true,
        desc_key: 'desc',
        has_asc: true,
        asc_key: 'asc',
        sort_type: 'DATE',
    },
    PBD: {
        has_desc: true,
        desc_key: 'pdesc',
        has_asc: true,
        asc_key: 'pasc',
        sort_type: 'DATE',
    },
    WS_CREATED_AT: {
        has_desc: true,
        desc_key: 'wtdesc',
        has_asc: true,
        asc_key: 'wtasc',
        sort_type: 'DATE',
    },
    PRIORITY: {
        has_asc: true,
        asc_key: 'fdsasc',
        has_desc: true,
        desc_key: 'fdsdesc',
        sort_type: 'DATE',
    },
    FIRST_FADL_DATE: {
        has_asc: true,
        asc_key: 'fdsasc',
        has_desc: true,
        desc_key: 'fdsdesc',
        sort_type: 'DATE',
    },
    APN: {
        has_desc: true,
        desc_key: 'apdesc',
        has_asc: true,
        asc_key: 'apasc',
        sort_type: 'NUM',
    },
    PN: {
        has_desc: true,
        desc_key: 'pndesc',
        has_asc: true,
        asc_key: 'pnasc',
        sort_type: 'NUM',
    },
    CITED_COUNT: {
        has_desc: true,
        desc_key: 'cdesc',
        sort_type: 'NUM',
    },
    PV: {
        has_desc: true,
        desc_key: 'vdesc',
        sort_type: 'NUM',
    },
    SIMPLE_FAMILY_COUNT: {
        has_desc: true,
        desc_key: 'spdesc',
        sort_type: 'NUM',
    },
    INPADOC_FAMILY_COUNT: {
        has_desc: true,
        desc_key: 'idesc',
        sort_type: 'NUM',
    },
    _NUM: {
        has_asc: true,
        sort_type: 'NUM',
    },
    _DATE: {
        has_asc: true,
        sort_type: 'DATE',
    },
    _STRING: {
        has_asc: true,
        sort_type: 'NUM',
    },
    _OPTION: {
        has_asc: true,
        sort_type: 'NUM',
    },
    SORT_SEQ_NUM: {
        has_asc: true,
        sort_type: 'NUM',
    },
};
